import { IssueSubtypeDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useQuery } from '@tanstack/react-query';

export interface UseIssueSubtypeParams {
  id: string;
}

export function useIssueSubtype({ id }: UseIssueSubtypeParams) {
  const api = useApi();

  return useQuery<IssueSubtypeDto, ExtendedAxiosError>({
    queryKey: ['issue-subtypes', id],
    queryFn: () => api.issueSubtypesApi.issueSubtype(id!).then((r) => r.data),
    enabled: !!id,
  });
}
